export const data = [
    // {
    //     value: "Scrap_Tire_By_Compound",
    //     reportName: "Tire Reports-Cost Per hour by Compound",
    // }, 
    {
        value: "All_Tire_Summary_Report",
        reportName: "All Tire Summary Report"
    }
];